import React from 'react';

const KPICard = ({ title, value, subtitle, trend, icon, className = '' }) => {
  return (
    <div className={`bg-[var(--clr-surface-card)] rounded-xl border border-gray-200 p-6 shadow-[var(--shadow-card)] hover:shadow-md transition-shadow ${className}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-[var(--clr-text-secondary)] mb-1">{title}</p>
          <p className="text-3xl font-semibold text-[var(--clr-text-primary)] mb-1">{value}</p>
          {subtitle && (
            <p className="text-sm text-[var(--clr-text-muted)]">{subtitle}</p>
          )}
          {trend && (
            <div className={`inline-flex items-center text-sm mt-2 font-medium ${
              trend > 0 ? 'text-[var(--clr-sev-blocked)]' : trend < 0 ? 'text-[var(--clr-sev-healthy)]' : 'text-[var(--clr-text-secondary)]'
            }`}>
              {trend > 0 ? '↑' : trend < 0 ? '↓' : '→'} {Math.abs(trend)}%
            </div>
          )}
        </div>
        {icon && (
          <div className="flex-shrink-0 ml-4">
            {icon}
          </div>
        )}
      </div>
    </div>
  );
};

export default KPICard;
